import React from 'react';
import { ChevronRight } from 'lucide-react';
import { BiometricStatusIcon } from './BiometricStatusIcon';
interface Employee {
  id: string;
  name: string;
  role: string;
  avatarUrl?: string;
  isActive: boolean;
  hasFingerprint: boolean;
  hasFace: boolean;
}
interface EmployeeCardProps {
  employee: Employee;
  onClick: () => void;
}
export function EmployeeCard({
  employee,
  onClick
}: EmployeeCardProps) {
  return <div onClick={onClick} className="bg-slate-800 rounded-xl p-4 border border-slate-700 flex items-center space-x-4 active:bg-slate-700 transition-colors cursor-pointer" data-id="element-31">
      {/* Avatar */}
      <div className="relative" data-id="element-32">
        <div className="w-12 h-12 rounded-full bg-slate-600 flex items-center justify-center text-lg font-bold text-white overflow-hidden" data-id="element-33">
          {employee.avatarUrl ? <img src={employee.avatarUrl} alt={employee.name} className="w-full h-full object-cover" data-id="element-34" /> : employee.name.charAt(0)}
        </div>
        <div className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-slate-800 ${employee.isActive ? 'bg-green-500' : 'bg-slate-500'}`} data-id="element-35" />
      </div>

      {/* Info */}
      <div className="flex-1 min-w-0" data-id="element-36">
        <h3 className="text-white font-medium truncate" data-id="element-37">{employee.name}</h3>
        <p className="text-slate-400 text-xs truncate" data-id="element-38">
          ID: {employee.id} • {employee.role}
        </p>
      </div>

      {/* Status Icons */}
      <div className="flex items-center space-x-2" data-id="element-39">
        <BiometricStatusIcon type="fingerprint" isEnrolled={employee.hasFingerprint} data-id="element-40" />
        <BiometricStatusIcon type="face" isEnrolled={employee.hasFace} data-id="element-41" />
        <ChevronRight size={16} className="text-slate-600 ml-1" data-id="element-42" />
      </div>
    </div>;
}